import { Props } from "country-flag-icons/react/3x2";
import { FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { BrokerOnboardingRequestsAdmin } from "../brokerOnboardingRequests";
import { CountryOnboardingRequestsAdmin } from "../countryOnboardingRequests";
import { AdminBrokers } from "../brokers";
import { AdminCountries } from "../countries";
import { BrokerTraderAccessAdmin } from "../brokerTraderAccess";
import { CountryTraderAccessAdmin } from "../countryTraderAccess";
import { AdminCounterparties } from "../counterparties";
import { AdminMergers } from "../mergers";
import { OnboardingRequestsAdmin } from "../onboardingRequests";
import { TraderAccessAdmin } from "../traderAccess";

export const AdminRoutes: FC<Props> = () => {
  return (
    <Routes>
      <Route path="counterparties/list" element={<AdminCounterparties />} />
      <Route
        path="counterparties/trader-access"
        element={<TraderAccessAdmin />}
      />
      <Route
        path="counterparties/onboarding-requests"
        element={<OnboardingRequestsAdmin />}
      />
      <Route path="brokers/list" element={<AdminBrokers />} />
      <Route
        path="brokers/trader-access"
        element={<BrokerTraderAccessAdmin />}
      />
      <Route
        path="brokers/onboarding-requests"
        element={<BrokerOnboardingRequestsAdmin />}
      />
      <Route path="mergers/list" element={<AdminMergers />} />
      <Route path="countries/list" element={<AdminCountries />} />
      <Route
        path="countries/trader-access"
        element={<CountryTraderAccessAdmin />}
      />
      <Route
        path="countries/onboarding-requests"
        element={<CountryOnboardingRequestsAdmin />}
      />
      <Route path="*" element={<Navigate to="counterparties/list" replace />} />
    </Routes>
  );
};
